import { useState } from 'react'
import { Form, Modal, Radio } from 'antd'
import type { ContractDocumentStatus } from '@super-mega/server/contracts/contract'
import { useAccess } from '@/hooks/use-access.ts'
import { canPerformAction } from '@/utils/action-access.ts'
import { CONTRACT_DOCUMENT_STATUS } from './const/contract-labels.ts'

export function ContractStatusModal({
  label,
  initialStatus,
  defaultStatus,
  pending,
  onSubmit,
  onClose
}: {
  label: string
  initialStatus?: ContractDocumentStatus
  defaultStatus?: ContractDocumentStatus
  pending: boolean
  onSubmit: (status: ContractDocumentStatus) => Promise<void>
  onClose: () => void
}) {
  const access = useAccess()
  const available = Object.entries(CONTRACT_DOCUMENT_STATUS).filter(([value]) =>
    canPerformAction(access.session, 'contract.document', value)
  )
  const [status, setStatus] = useState<ContractDocumentStatus>(
    initialStatus ?? defaultStatus ?? (available[0]?.[0] as ContractDocumentStatus | undefined) ?? 'confirmed'
  )
  return (
    <Modal
      open
      width="36rem"
      title={initialStatus ? `确认修改为${CONTRACT_DOCUMENT_STATUS[status].label}？` : '修改合同状态'}
      onCancel={onClose}
      onOk={() => void onSubmit(status)}
      closable={!pending}
      confirmLoading={pending}
      okText="确认修改"
      cancelText="取消"
      okButtonProps={{
        danger: status === 'voided',
        disabled: pending || !canPerformAction(access.session, 'contract.document', status)
      }}
      cancelButtonProps={{ disabled: pending }}
      mask={{ closable: !pending }}
      keyboard={!pending}
    >
      <Form layout="vertical" className="mt-5">
        <Form.Item label="操作范围">
          <div className="bg-surface-muted text-content rounded-lg px-4 py-3 text-sm leading-6 wrap-anywhere">
            {label}
          </div>
        </Form.Item>
        <Form.Item label="目标状态" className="mb-3!">
          <Radio.Group
            block
            aria-label="目标状态"
            optionType="button"
            buttonStyle="solid"
            value={status}
            disabled={pending || Boolean(initialStatus)}
            onChange={(event) => setStatus(event.target.value as ContractDocumentStatus)}
            options={available.map(([value, item]) => ({ value, label: item.label }))}
          />
        </Form.Item>
        <p className="text-content-muted m-0 text-sm leading-6">
          仅修改合同状态，不影响订单和账单。已处于目标状态的合同将跳过。
        </p>
      </Form>
    </Modal>
  )
}
